var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('custom-tag',{attrs:{"title":_vm.typeOfTags.title,"tooltip-message":_vm.typeOfTags.tooltipMessage,"type":_vm.typeOfTags.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }